// @ts-check

export const ComponentState = Object.freeze({
  INITIAL: 0,
  NEW: 1,
  EDIT: 2,
});

/**
 * Enumerado para clasificiar las diferentes documentos de disponibles en ERPagro.
 */
export const TipoDocumento = Object.freeze({
  ND: 0, // No definido
  ALBARAN_COMPRA: 1,
  PEDIDO_VENTA: 2,
  LISTA_UBICACION: 3, // Location  List (ListaDeUbicaciones en ERP)
  LISTA_UBICACION_PREPARACION: 4, // Picking List (ListaDeUbicacionesParaRecoleccion en ERP)
  PARTE_PRODUCCION: 5, // Picking List
});

/**
 * Enumerated type for classifying different ERP components.
 * @type {import('@erpagroapp/types').ComponenteString}
 */
export const ComponenteERP = Object.freeze({
  INDEFINIDO: 'Indefinido',
  COMPRAS: 'Compras',
  VENTAS: 'Ventas',
  ALMACEN: 'Almacen',
  CONTABILIDAD: 'Contabilidad',
  COBROS: 'Cobros',
  PAGOS: 'Pagos',
  CAJA: 'Caja',
  MODELOSOFICIALES: 'Modelosoficiales',
  COMUN: 'Comun',
  SUMINISTROS: 'Suministros',
  SEMILLEROS: 'Semilleros',
  SECTORAGRICOLA: 'SectorAgricola',
  COMERCIALIZACION: 'Comercializacion',
  NOMINA: 'Nomina',
  PRODUCCION: 'Produccion',
  CONTROLPRESENCIA: 'ControlPresencia',
  GESTIONNEGOCIOCOMUN: 'GestionNegocioComun',
  ALHONDIGAS: 'Alhondigas',
  CONTROLCALIDAD: 'ControlCalidad',
  TRAZABILIDADAUTOMATIZADA: 'TrazabilidadAutomatizada',
  OPFH: 'OPFH',
  VITIVINICOLA: 'Vitivinicola',
  DOCUMENTOSADUANEROS: 'DocumentosAduaneros',
  SECTOROLEICO: 'SectorOleico',
  GESTIONPLANTAS: 'GestionPlantas',
  VIVERO: 'Vivero',
  INCIDENCIAS: 'Incidencias',
  MERCADO: 'Mercado',
});

/**
 * Enumerated type for classifying different components.
 * @type {typeof import('@erpagroapp/types').Componente}
 */
export const Componente = Object.freeze({
  Indefinido: -1,
  Compras: 0,
  Ventas: 1,
  Almacen: 2,
  Contabilidad: 3,
  Cobros: 4,
  Pagos: 5,
  Caja: 6,
  Modelosoficiales: 7,
  Comun: 8,
  Suministros: 9,
  Semilleros: 10,
  SectorAgricola: 11,
  Comercializacion: 12,
  Nomina: 13,
  Produccion: 14,
  ControlPresencia: 15,
  GestionNegocioComun: 16,
  Alhondigas: 17,
  ControlCalidad: 18,
  TrazabilidadAutomatizada: 19,
  OPFH: 20,
  Vitivinicola: 21,
  DocumentosAduaneros: 22,
  SectorOleico: 23,
  GestionPlantas: 24,
  Vivero: 25,
  Incidencias: 26,
  Mercado: 27,
});

/**
 * Enumerated type for application types.
 * @type {typeof import('@erpagroapp/types').TipoAplicacionCliente}
 */
export const TipoAplicacionCliente = Object.freeze({
  WinForm: 0,
  Web: 1,
  Personalizada: 2,
  PDA: 3,
  TIS: 4,
  ERPAgroApp: 5,
});

/**
 * Enumerated type for article types.
 * @type {typeof import('@erpagroapp/types').TipoArticulo}
 */
export const TipoArticulo = Object.freeze({
  Palet: 0,
  Envase: 1,
  Producto: 2,
});

/**
 * Enumerated type for block types.
 * @type {typeof import('@erpagroapp/types').TipoBloqueo}
 */
export const TipoBloqueo = Object.freeze({
  FueraDeUso: 5,
  Bloqueo: 10,
  Aviso: 15,
});

/**
 * Enumerated type for block types.
 * @type {typeof import('@erpagroapp/types').TipoBloqueoEntidad}
 */
export const TipoBloqueoEntidad = Object.freeze({
  Bloqueo: 0,
  Aviso: 1,
});

/**
 * Enumerated type for block types.
 * @type {typeof import('@erpagroapp/types').TipoVentaBloqueo}
 */
export const TipoVentaBloqueo = Object.freeze({
  SinBloquear: 0,
  BloqueoEntradas: 1,
  BloqueoListines: 2,
  BloqueoEntradasListines: 3,
  BloqueoGeneral: 4,
});

export const ParameterSource = Object.freeze({
  ERP: 0,
  WS: 1,
});

export const ConfigurationParameterTypes = Object.freeze({
  STRING: 0,
  NUMBER: 1,
  BOOLEAN: 2,
  OBJECT: 3,
  JSON: 4,
});

export const WorkEnvironmentOperations = Object.freeze(/** @type {const} */ ({
  WORK_ENVIRONMENT: {
    Id: 6284,
    Codigo: '6284',
    Nombre: 'Permitir cambio de Entorno de Trabajo',
  },
  ENTERPRISE_GROUP: {
    Id: 6183,
    Codigo: '6183',
    Nombre: 'Permitir cambio de Grupo Empresarial',
  },
  COMPANY: {
    Id: 6182,
    Codigo: '6182',
    Nombre: 'Permitir cambio de Empresa',
  },
  CENTER: {
    Id: 6181,
    Codigo: '6181',
    Nombre: 'Permitir cambio de Centro',
  },
  WAREHOUSE: {
    Id: 6179,
    Codigo: '6179',
    Nombre: 'Permitir cambio de Almacén',
  },
}));
